const previewHosts = new Set(['::1', '[::1]', '127.0.0.1', 'dev.nitrogenx.co', 'localhost', 'nitrogenx.co', 'www.nitrogenx.co']);

export const isPoohHost = (hostname: string, pathname: string): boolean => (
  hostname === 'pooh.nitrogenx.co' || hostname === 'www.pooh.nitrogenx.co' ||
  (previewHosts.has(hostname) && (pathname === '/pooh' || pathname.startsWith('/pooh/')))
);
